import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { CrudViewComponent } from '../../../shared/components/crud/view/view';
import { MateriaInterface } from '../../../models/materia.model';
import { MateriasService } from '../../../core/materias.service';
import { BaseCrud, typeAction } from '../../../shared/baseCrud.component';
import { MATERIAS_COLUMN_NAMES_DETAIL } from '../../../constants/materias.constants';

@Component({
  selector: 'app-materias-view',
  imports: [CommonModule, MatListModule, CrudViewComponent],
  templateUrl: './materias-view.component.html',
  styleUrls: ['./materias-view.component.scss']
})
export class MateriasViewComponent extends BaseCrud<MateriaInterface> {
  type = <typeAction>'view';
  apiService = inject(MateriasService);
  columnNames = MATERIAS_COLUMN_NAMES_DETAIL;
}
